import { Head, usePage } from '@inertiajs/react'
import type { ReactNode } from 'react'
import AppLayout from '@/components/AppLayout'
import WikiLayout from '@/components/WikiLayout'
import type { WikiPageIndexPageProps } from '@/types'

function WikiPageIndex() {
  const { project, wiki_page, wiki_pages } = usePage<WikiPageIndexPageProps>().props

  return (
    <>
      <Head title={`Wiki - ${project.name}`} />
      <WikiLayout
        project={project}
        wikiPage={wiki_page}
        wikiPages={wiki_pages}
      />
    </>
  )
}

WikiPageIndex.layout = (page: ReactNode) => <AppLayout padding={0}>{page}</AppLayout>

export default WikiPageIndex
